<div class="tab-filter">
  <shared-filter-bar
    [text]="true"
    [organizations]="true"
    [resultsCount]="recordCount"
    [(filteredText)]="filteredText"
    [(filteredOrganizations)]="filteredOrganizations"
    (refreshData)="refreshPublishData()"
  >
    <!-- <ng-container other-buttons>
    <button styles-icon-button class="icon-button" (click)="state = 'list'">
      <mat-icon>format_list_bulleted</mat-icon>
    </button>
    <button styles-icon-button class="icon-button" (click)="state = 'image'">
      <mat-icon>grid_on</mat-icon>
    </button>
  </ng-container>-->
  </shared-filter-bar>
  <!-- <mat-progress-bar *ngIf="loading?.loadingObs | async" mode="indeterminate"></mat-progress-bar> -->
</div>

<div class="spacer"></div>
@if (searchResults$ | async; as searchResults) { @if (searchResults?.items?.length ) {
<div class="search-wrapper">
  <search-results-box [results]="$safeNavigationMigration(searchResults?.items)"></search-results-box>
</div>
} @else {
<div class="search-wrapper">
  <div class="no-data">No Data Found</div>
</div>
} @if (searchResults.currentPage < searchResults.totalPages) {
<framework-paging-button (frameworkInView)="options.loadMore()" [loading]="options.loading"> </framework-paging-button>
} } @else {
<div class="search-wrapper">
  <elements-loading-spinner></elements-loading-spinner>
</div>
}
